import { typeCheckAppModule } from "src/utils";
import { NAME } from "./constants";
import { CopyTiers } from "./CopyTiers";

export const copyTiers = typeCheckAppModule({
    NAME,
    Container: CopyTiers,
});
